import type { ZudokuConfig } from 'zudoku'

const config: ZudokuConfig = {
  basePath: '/docs',
  site: {
    title: 'SealRoute Docs'
  },
  metadata: {
    title: 'SealRoute Docs',
    description: 'Reference, SDKs, guides and webhooks for the SealRoute API.',
    applicationName: 'SealRoute Docs',
    keywords: ['sealroute', 'api', 'esign', 'documents', 'webhooks']
  },
  apis: {
    type: 'file',
    input: './apis/openapi.json',
    path: '/api'
  },
  docs: {
    files: '/pages/**/*.{md,mdx}'
  },
  redirects: [
    { from: '/', to: '/getting-started' }
  ],
  navigation: [
    {
      type: 'category',
      label: 'Get Started',
      items: ['getting-started']
    },
    {
      type: 'link',
      to: '/api',
      label: 'API Reference'
    },
    {
      type: 'category',
      label: 'SDKs',
      items: [
        'sdk/shell',
        'sdk/javascript',
        'sdk/typescript',
        'sdk/nodejs',
        'sdk/python',
        'sdk/ruby',
        'sdk/php',
        'sdk/go',
        'sdk/java',
        'sdk/csharp'
      ]
    },
    {
      type: 'category',
      label: 'Guides',
      items: [
        'guides/docx-variables',
        'guides/template-tags'
      ]
    },
    {
      type: 'category',
      label: 'Webhooks',
      items: [
        'webhooks/form-webhook',
        'webhooks/submission-webhook',
        'webhooks/template-webhook',
        'webhooks/phone-otp-webhook'
      ]
    }
  ],
  defaults: {
    apis: {
      examplesLanguage: 'shell'
    }
  }
}

export default config
